import { useState } from 'react';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import { useNavigate, useParams } from "react-router-dom";
import { useMsal } from '@azure/msal-react';
import useSensorStore from '../store/sensorStore';
import { msalConfig } from '../auth/authConfig';
import { errorHandler } from '../utils/helpers';
import { SensorsListItem } from '../definitions/sensor';
import { acquireToken } from '../utils/auth';

interface FetchData {
  id: string | number;
  token: string | null;
  updateEditSensorData: (data: SensorsListItem) => void;
  setError: (data: any) => any;
  setLoading: (data: any) => any;
};

const fetchData = async ({
    id,
    token,
    updateEditSensorData,
    setError,
    setLoading,
  }: FetchData) => {
  setLoading(true);
  try {
    const path = `${window.__env.REACT_APP_API_URL || process.env.REACT_APP_API_URL}/Sensor/${id}`
    const response = await axios.get(path, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json, text/plain, */*',
      },
    });
    const sensor = response.data;
    updateEditSensorData(sensor);
  } catch (error) {
    errorHandler(error, setError);
  } finally {
    setLoading(false);
  }
};

interface FetchSensors {
  fetchSensor: () => void;
  loading: boolean;
  error: Error | null;
};

const useFetchSensorById = (): FetchSensors => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const { updateEditSensorData } = useSensorStore();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchSensor = async () => {
    if (accounts.length > 0) {
      const accessTokenRequest = {
        scopes: [`${msalConfig.auth.clientId}/.default`],
        account: accounts[0],
      };
      if (!id) return navigate('/');
      try {
        const accessToken = await acquireToken(instance, accessTokenRequest);
        fetchData({
          id,
          token: accessToken,
          updateEditSensorData,
          setError,
          setLoading,
        });
      } catch (error) {
        errorHandler(error, setError);
      }
    } else {
      navigate('/sign-in');
    }
  }

  return { fetchSensor, loading, error };
};

export default useFetchSensorById;
